import {logErrorToSentry} from "./errors/logErrorToSentry";

export const loadGoogleTagManager = () =>  {
    return new Promise<void>((resolve, reject) => {
        const gtmId = import.meta.env.VITE_GTM;
        if (!window.google_tag_manager || !window.google_tag_manager[gtmId]) {
            (function (w: any, d: any, s: any, l: any, i: any) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    script = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                script.async = true;
                script.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;

                script.onload = () => resolve();
                script.onerror = (error: any) => reject(new Error('Failed to load GTM script.'));

                f.parentNode.insertBefore(script, f);
            })(window, document, 'script', 'dataLayer', gtmId);
        } else {
            resolve();
        }
    });
}


export const GA_EVENTS = {
    SIGN_UP: 'Signup_APP',
    SIGN_UP_FAIL: 'Signup_APP_FAIL'
} as const;

export type GA_EVENT = typeof GA_EVENTS[keyof typeof GA_EVENTS];

export const sendGAEvent = async (gaEvent: GA_EVENT ,userId?: string) => {
    try {
        await loadGoogleTagManager();
        const gaData: any = {
            event: gaEvent
        };

        if (userId) {
            gaData.userId = userId;
        }

        window.dataLayer.push(gaData);
    } catch(error: any) {
        logErrorToSentry(error)
    }
}

export const getUTMFromCookie = (name: string = 'utm_data') => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return JSON.parse(decodeURIComponent(parts.pop()!.split(';').shift()!));
    }
    return null;
}
